import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";

const MapsButton = ({ location, buttonColors }) => {
  const buttonStyle = {
    backgroundColor: buttonColors.primary,
  };
  const iconStyle = {
    color: buttonColors.icon,
  };
  return (
    <a
      href={location}
      target="_blank"
      rel="noopener noreferrer"
      className="icon-button"
      style={buttonStyle}
    >
      <FontAwesomeIcon icon={faMapMarkerAlt} style={iconStyle} />
    </a>
  );
};

export default MapsButton;
